import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import "@/index.css";

import Home from "@/pages/Home";
import Method from "@/pages/Method";
import Identify from "@/pages/Identify";
import Reading from "@/pages/Reading";
import Payment from "@/pages/Payment";
import PaymentConfirmed from "@/pages/PaymentConfirmed";
import PaymentCancelled from "@/pages/PaymentCancelled";
import Revealing from "@/pages/Revealing";
import Report from "@/pages/Report";
import Retrieve from "@/pages/Retrieve";
import Contact from "@/pages/Contact";
import PrivacyPolicy from "@/pages/legal/PrivacyPolicy";
import SalesTerms from "@/pages/legal/SalesTerms";
import UseTerms from "@/pages/legal/UseTerms";
import CookiesPolicy from "@/pages/legal/CookiesPolicy";

export default function App() {
  return (
    <BrowserRouter>
      <Toaster theme="dark" position="top-center" toastOptions={{ style: { background: "#0d0d0d", color: "#F7F5F0", border: "1px solid #2A2A2A" } }} />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/methode" element={<Method />} />
        <Route path="/commencer" element={<Identify />} />
        <Route path="/lecture/:token" element={<Reading />} />
        <Route path="/paiement/:token" element={<Payment />} />
        <Route path="/paiement-confirme" element={<PaymentConfirmed />} />
        <Route path="/paiement-annule" element={<PaymentCancelled />} />
        <Route path="/revelation/:token" element={<Revealing />} />
        <Route path="/rapport/:token" element={<Report />} />
        <Route path="/retrouver" element={<Retrieve />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/politique-de-confidentialite" element={<PrivacyPolicy />} />
        <Route path="/conditions-de-vente" element={<SalesTerms />} />
        <Route path="/conditions-utilisation" element={<UseTerms />} />
        <Route path="/politique-des-temoins" element={<CookiesPolicy />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}
